export function initFilterSidebar() {
    // Handle Expertises filters (single selection with scroll functionality)
    const expertisesFilters = document.querySelector('#expertises-filters');
    if (expertisesFilters) {
        const expertisesItems = expertisesFilters.querySelectorAll('.filter-sidebar__item');
        let isScrolling = false;
        
        // Click to scroll functionality
        expertisesItems.forEach(item => {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                
                const targetId = item.dataset.target;
                const targetElement = document.getElementById(targetId);
                
                if (targetElement) {
                    isScrolling = true;
                    
                    // Remove active from all other items
                    expertisesItems.forEach(otherItem => {
                        otherItem.classList.remove('active');
                        const otherIcon = otherItem.querySelector('.tag__icon');
                        if (otherIcon) {
                            otherIcon.classList.remove('active');
                        }
                    });
                    
                    // Add active to clicked item
                    item.classList.add('active');
                    const icon = item.querySelector('.tag__icon');
                    if (icon) {
                        icon.classList.add('active');
                    }
                    
                    // Smooth scroll to target
                    const headerHeight = 100; // Adjust based on your header height
                    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
                    
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                    
                    // Reset scrolling flag after animation completes
                    setTimeout(() => {
                        isScrolling = false;
                    }, 1000);
                }
            });
        });
        
        // Scroll to activate functionality
        function updateActiveFilter() {
            if (isScrolling) return;
            
            const scrollPosition = window.pageYOffset;
            const triggerPoint = 300; // Activate when element is 300px from top
            let activeItem = null;
            
            expertisesItems.forEach(item => {
                const targetId = item.dataset.target;
                const targetElement = document.getElementById(targetId);
                
                if (targetElement) {
                    const elementRect = targetElement.getBoundingClientRect();
                    const elementTop = elementRect.top;
                    const elementBottom = elementRect.bottom;
                    
                    // Check if element is in the activation zone (around 300px from top)
                    if (elementTop <= triggerPoint && elementBottom > triggerPoint) {
                        activeItem = item;
                    }
                }
            });
            
            // Update active states
            if (activeItem) {
                expertisesItems.forEach(item => {
                    item.classList.remove('active');
                    const icon = item.querySelector('.tag__icon');
                    if (icon) {
                        icon.classList.remove('active');
                    }
                });
                
                activeItem.classList.add('active');
                const activeIcon = activeItem.querySelector('.tag__icon');
                if (activeIcon) {
                    activeIcon.classList.add('active');
                }
            }
        }
        
        // Throttled scroll listener
        let scrollTimeout;
        window.addEventListener('scroll', () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(updateActiveFilter, 100);
        });
        
        // Initial check on page load
        updateActiveFilter();
    }
    
    // Handle Success Stories filters (multiple selection with filtering)
    const successFilters = document.querySelector('#success-stories-filters');
    if (successFilters) {
        const successItems = successFilters.querySelectorAll('.filter-sidebar__item');
        const successStoryCards = document.querySelectorAll('.story-card');
        
        function filterSuccessStories() {
            const activeFilters = Array.from(successItems)
                .filter(item => item.classList.contains('active'))
                .map(item => item.dataset.filter);
            
            successStoryCards.forEach(card => {
                if (activeFilters.length === 0) {
                    // No filters selected - show all cards
                    card.closest('a').style.display = 'block';
                } else {
                    // Check if card has any of the selected categories
                    const cardCategories = (card.dataset.categories || '').split(',').filter(cat => cat.trim() !== '');
                    const hasMatchingCategory = activeFilters.some(filter => 
                        cardCategories.includes(filter)
                    );
                    
                    card.closest('a').style.display = hasMatchingCategory ? 'block' : 'none';
                }
            });
        }
        
        // Check URL parameter for filter
        const urlParams = new URLSearchParams(window.location.search);
        const filterParam = urlParams.get('filter');
        
        if (filterParam) {
            // Find and activate the corresponding filter
            successItems.forEach(item => {
                if (item.dataset.filter === filterParam) {
                    item.classList.add('active');
                    const icon = item.querySelector('.tag__icon');
                    if (icon) {
                        icon.classList.add('active');
                    }
                }
            });
            
            // Remove the filter parameter from URL to return to default format
            const url = new URL(window.location);
            url.searchParams.delete('filter');
            window.history.replaceState({}, '', url);
        }
        
        successItems.forEach(item => {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                item.classList.toggle('active');
                const icon = item.querySelector('.tag__icon');
                if (icon) {
                    icon.classList.toggle('active');
                }
                filterSuccessStories();
            });
        });
        
        // Initial filter on page load
        filterSuccessStories();
    }
    
    // Handle Clients filters (multiple selection with filtering)
    const clientsFilters = document.querySelector('#clients-filters');
    if (clientsFilters) {
        const clientsItems = clientsFilters.querySelectorAll('.filter-sidebar__item');
        const clientCards = document.querySelectorAll('.clients-card');
        
        function filterClients() {
            const activeFilters = Array.from(clientsItems)
                .filter(item => item.classList.contains('active'))
                .map(item => item.dataset.filter);
            
            clientCards.forEach(card => {
                if (activeFilters.length === 0) {
                    // No filters selected - show all cards
                    card.style.display = 'block';
                } else {
                    // Check if card has any of the selected sectors
                    const cardSectors = (card.dataset.sectors || '').split(',').filter(sector => sector.trim() !== '');
                    const hasMatchingSector = activeFilters.some(filter => 
                        cardSectors.includes(filter)
                    );
                    
                    card.style.display = hasMatchingSector ? 'block' : 'none';
                }
            });
        }
        
        clientsItems.forEach(item => {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                item.classList.toggle('active');
                const icon = item.querySelector('.tag__icon');
                if (icon) {
                    icon.classList.toggle('active');
                }
                filterClients();
            });
        });
        
        // Initial filter on page load
        filterClients();
    }
}